import { Alert, AlertDescription, AlertIcon, type AlertProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { BidV2Dto } from "../../../../autogen/bff-api";
import { isBidV2Editable } from "./publicBidEditability";

export const RoundBidDocumentsNotice = ({ bid, ...alertProps }: { bid: BidV2Dto | undefined } & AlertProps) => {
  const { t } = useTranslation();
  if (!bid?.forNegotiationRound || !isBidV2Editable(bid)) return null;
  return (
    <Alert status="info" rounded="md" fontSize="sm" {...alertProps}>
      <AlertIcon />
      <AlertDescription>
        {t("Documents don't carry over from your previous bid. Upload again the ones that still apply.")}
      </AlertDescription>
    </Alert>
  );
};
